import React, { useState, useLayoutEffect } from 'react';
import moment from 'moment-timezone';
import useResizeObserver from '@react-hook/resize-observer';
import Request from 'files/Request.js';

export default {
    addressLookup: async (utils, text, session) => {
        return new Promise(async (resolve, reject) => {
            try {
                let { places } = await Request.get(utils, '/resources/', {
                    search_text: text,
                    session: session,
                    type: 'address_lookup',
                    use_autocomplete: true
                })
                resolve({
                    results: places.map((result, index) => {
                        return {
                            address: result.address,
                            key: index,
                            name: result.name || 'Name Unavailable',
                            place_id: result.place_id,
                            ...result.location && {
                                location: {
                                    latitude: result.location.lat,
                                    longitude: result.location.long
                                }
                            }
                        }
                    })
                })

            } catch(e) {
                reject(e);
            }
        })
    },
    format: {
        address: props => {

            // return formatted address in accordance with google auto complete formatting
            let { street_address_1, street_address_2, country, city, name, state, zipcode } = props || {};
            if(street_address_1 && city && state && zipcode) {
                return `${street_address_1}${street_address_2 ? ` ${street_address_2}` : ''}, ${city}, ${state} ${zipcode}${country ? `, ${country}` : ''}`
            }

            // return ala-carte address components as they are found
            let values = [ name, street_address_1, street_address_2, city, state, zipcode, country ].filter(val => {
                return val && val.toString().length > 1 ? true : false;
            });
            return values.length > 0 ? values.join(', ') : null;
        },
        date: (date, withoutTime = false) => {
            if(!date ) {
                return 'Unknown';
            }
            let next_date = moment(date);
            if(next_date.isValid() !== true) {
                return 'Date is not valid';
            }
            if(moment().isSame(next_date, 'day')) {
                return moment(date).format(withoutTime ? '[Today] MMMM Do' : '[Today at] h:mma');
            }
            if(moment().subtract(1, 'days').isSame(next_date, 'day')) {
                return moment(date).format(withoutTime ? '[Yesterday] MMMM Do' : '[Yesterday at] h:mma');
            }
            if(next_date > moment() && next_date <= moment().add(6, 'days')) {
                return moment(date).format(withoutTime ? 'dddd MMMM Do' : 'dddd [at] h:mma');
            }
            if(moment().isSame(next_date, 'year')) {
                return moment(date).format(withoutTime ? 'MMMM Do' : 'MMM Do [at] h:mma');
            }
            return moment(date).format('MM/DD/YYYY');
        }
    },
    geocode: async (utils, location) => {
        return new Promise(async (resolve, reject) => {
            try {
                let { result } = await Request.get(utils, '/resources/', {
                    type: 'geocode_location',
                    ...location
                })
                resolve({
                    ...result,
                    ...result.location && {
                        location: {
                            latitude: result.location.lat,
                            longitude: result.location.long
                        }
                    }
                });

            } catch(e) {
                reject(e);
            }
        })
    },
    hexToRGBA: (hex, alpha) => {
        var c;
    	if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    		c= hex.substring(1).split('');
    		if(c.length === 3){
    			c= [c[0], c[0], c[1], c[1], c[2], c[2]];
    		}
    		c= '0x'+c.join('');
    		return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + alpha + ')';
    	}
    	return hex;
    },
    isMobile: () => {
        return window.innerWidth < 767.98;
    },
    safeArea: () => {
        let doc = getComputedStyle(document.documentElement);
        return {
            top: doc.getPropertyValue('--sat') || 0,
            bottom: doc.getPropertyValue('--sab') || 0,
            left: doc.getPropertyValue('--sal') || 0,
            right: doc.getPropertyValue('--sar') || 0
        }
    },
    senderTypes: {
        button: 1
    },
    sleep: (value = 0) => {
        return new Promise(resolve => {
            return setTimeout(resolve, value * 1000);
        });
    }
};

export const useSize = target => {

    const [size, setSize] = useState();

    useLayoutEffect(() => {
        setSize(target.current.getBoundingClientRect())
    }, [target]);

    useResizeObserver(target, entry => setSize(entry.contentRect))
    return size
}
